import React from 'react';
import useResponsiveSpacesNavigation from '@app/hooks/useResponsiveSpacesNavigation';
import ResponsiveModalPageSwitcher from '../common/ResponsiveModalPageSwitcher';
import SpacesListModal from '../AllSpaces/SpacesListModal';
import AllSpacesPage from '../AllSpaces/AllSpacesPage';

const HomeSpacesModalManager: React.FC = () => {
  const { isModalOpen, modalType, closeAllSpacesModal } =
    useResponsiveSpacesNavigation();

  return (
    <ResponsiveModalPageSwitcher
      isOpen={isModalOpen}
      onClose={closeAllSpacesModal}
      modalComponent={
        <SpacesListModal
          isOpen={isModalOpen}
          onClose={closeAllSpacesModal}
          type={modalType}
        />
      }
      pageComponent={
        <AllSpacesPage onClose={closeAllSpacesModal} filterType={modalType} />
      }
    />
  );
};

export default HomeSpacesModalManager;
